import Factory from '../factory';

const schema = Factory.schema('locations');

export default schema;
